import request from '@/utils/request'
import https from '@/utils/https.js'
export function getScoreLine(local_type_id,area) {
    return https({
        url: '/api/sim/getScoreLine',
        method: 'post',
        data: {
            local_type_id: local_type_id,
            area: area
        }
    })
}
export function getSearchDic() {
    return https({
        url: '/api/school/get_search_dic',
        method: 'post',
        data: {
        }
    })
}
export function getMajorLevel1(local_batch_id) {
    return https({
        url: '/api/school/get_hot_level2',
        method: 'post',
        data: {
            local_batch_id: local_batch_id
        }
    })
}
export function getMajorLevel2(level2) {
    return https({
        url: '/api/school/get_hot_special_list',
        method: 'post',
        data: {
            level2: level2
        }
    })
}
export function getSchoolList(params) {
    const form = { ...params }
    form.area = localStorage.getItem('area')
    return https({
        url: '/api/Sim/getSchoolList',
        method: 'post',
        data: form
    })
}
export function getSpecialList(data) {
    return https({
        url: '/api/sim/getSpecialList',
        method: 'post',
        data: data
    })
}
export function planSubmit(data) {
    return request({
        url: '/web/Sim/planSubmit',
        method: 'post',
        data: {
            area: localStorage.getItem('area'),
            score: data.score,
            local_type_id: data.local_type_id,
            local_batch_type: data.local_batch_type,
            plan_type: data.plan_type,
            plan_base_info: JSON.stringify(data.plan_base_info),
            plan_title: data.plan_title,
            plan_desc: data.plan_desc,
            avg_percent: data.avg_percent,
            json_str: JSON.stringify(data.json_str)
        }
    })
}
export function getMyPlanList(page) {
    return request({
        url: '/web/Sim/getMyPlanList',
        method: 'post',
        data: {
            page: page,
            size: '10'
        }
    })
}
export function getMyPlanDetail(id) {
    return request({
        url: '/web/Sim/getMyPlanDetail',
        method: 'post',
        data: {
            id: id
        }
    })
}
export function deleteMyPlan(id) {
    return request({
        url: '/web/Sim/deleteMyPlan',
        method: 'post',
        data: {
            id: id
        }
    })
}
export function getSearchSchoolList(scl_name) {
    return https({
        url: '/api/school/getSearchSchoolList',
        method: 'post',
        data: {
            scl_name: scl_name
        }
    })
}
export function geSearchSpecialList(special_name) {
    return https({
        url: '/api/special/geSearchSpecialList',
        method: 'post',
        data: {
            special_name: special_name
        }
    })
}
export function getSearchJobList(job_name) {
    return https({
        url: '/api/job/getSearchJobList',
        method: 'post',
        data: {
            job_name: job_name
        }
    })
}
export function planSmartSubmit(form) {
    return https({
        url: '/api/sim/planSmartSubmit',
        method: 'post',
        data: {
            score: form.score,
            local_type_id: form.local_type_id,
            local_batch_type: form.local_batch_type,
            area: localStorage.getItem("area")
        }
    })
}
export function getVirtualHistoryData(form) {
    return request({
        url: '/web/sim/getVirtualHistoryData',
        method: 'post',
        data: {
            score: form.score,
            local_type_id: form.local_type_id,
            local_batch_type: form.local_batch_type,
            area: localStorage.getItem("area")
        }
    })
}
export function getMyVirtualPlanList() {
    return request({
        url: '/web/sim/getMyVirtualPlanList',
        method: 'post',
        data: {}
    })
}
export function editPlanSubmit(data) {
    return request({
        url: '/web/sim/planEdit',
        method: 'post',
        data: {
            id: data.id,
            area: localStorage.getItem('area'),
            score: data.score,
            local_type_id: data.local_type_id,
            local_batch_type: data.local_batch_type,
            plan_type: data.plan_type,
            plan_base_info: JSON.stringify(data.plan_base_info),
            plan_title: data.plan_title,
            plan_desc: data.plan_desc,
            avg_percent: data.avg_percent,
            json_str: JSON.stringify(data.json_str)
        }
    })
}

export function getPlanCount() {
    return https({
        url: '/api/plan',
        method: 'post',
        data: {
            area: localStorage.getItem('area'),
            year: localStorage.getItem('gk_year')
        }
    })
}

export function getSpecialListById(id) {
    return https({
        url: '/api/sim/getSpecialListById',
        method: 'post',
        data: {
            id: id
        }
    })
}




